import {
  AuthCredential,
  fetchSignInMethodsForEmail,
  getRedirectResult as firebaseGetRedirectResult,
  linkWithCredential,
  signInWithCustomToken as firebaseSignInWithCustomToken, signInWithEmailAndPassword,
  signInWithRedirect,
  confirmPasswordReset, sendPasswordResetEmail
} from "@firebase/auth";
import {auth} from "./firebase-config";
import {AuthProviderType, getProvider} from "../domain/providers";
import {getAccountApiUrl} from "../env/env";

export const signInWithCustomToken = async (token: string): Promise<void> => {
  await firebaseSignInWithCustomToken(auth, token)
}

export const signInWithSsoProvider = async (authProvider: AuthProviderType) => {
  return signInWithRedirect(auth, getProvider(authProvider))
}

export const signInWithEmailPassword = async (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const fetchSignInMethods = async (email: string): Promise<AuthProviderType[]> => {
  const signInMethods = await fetchSignInMethodsForEmail(auth, email)
  return signInMethods.map(method => method as AuthProviderType);
};

export const fetchFirstSignInMethod = async(email: string): Promise<AuthProviderType | undefined> => {
  const methods = await fetchSignInMethods(email);
  if (methods.length > 0) {
    return methods[0] as AuthProviderType;
  }
  return undefined;
}

export const getRedirectResult = async () => {
  return firebaseGetRedirectResult(auth)
}

export const linkAccount = async (credential: AuthCredential) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error("No current user");
  }
  await linkWithCredential(currentUser, credential)
};

export const triggerResetPassword = async (email: string) => {
  const uri = getAccountApiUrl("/password-resets")
  const res = await fetch(uri, {method: "post", body: JSON.stringify({email})})
  if (!res.ok) {
    throw new Error("password reset error");
  }
}

export const resetPasswordWithOobCode = (oobCode: string, newPassword: string): Promise<void> => {
  return confirmPasswordReset(auth, oobCode, newPassword);
}

export const reloadCurrentUser = async () => {
  return auth.currentUser?.reload();
}
